var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkgreen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0f3f2e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.29,39.25l8.99,8.99-30.28,30.27L4.72,48.23l8.95-8.95c-.07.48-.12.95-.12,1.46,0,1.85.63,3.64,1.8,5.1l-2.41,2.39,22.06,22.07,22.08-22.07-2.43-2.43c1.14-1.44,1.76-3.22,1.76-5.07,0-.51-.04-1.02-.12-1.49h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m35,21.5c4.75,0,8.6,3.85,8.6,8.6,0,3.5-2.09,6.51-5.1,7.86,3.79,1.43,6.49,5.08,6.49,9.36v10.82l-9.99,10.01-9.99-10.01v-10.82c0-4.27,2.71-7.93,6.49-9.36-3.01-1.35-5.1-4.36-5.1-7.86,0-4.75,3.85-8.6,8.6-8.6h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m21.77,34c-3.71,0-6.72,3.01-6.72,6.74,0,2.73,1.64,5.08,3.99,6.14-1.21.46-2.29,1.2-3.13,2.16l7.57,7.56v-9.29c0-2.43.76-4.66,2.04-6.52.69-.99,1.53-1.86,2.48-2.6-1-2.45-3.41-4.19-6.23-4.19h0Zm26.42,0c3.71,0,6.72,3.01,6.72,6.74,0,2.73-1.63,5.08-3.98,6.14,1.21.46,2.31,1.21,3.15,2.18l-7.6,7.58v-9.32c0-2.43-.76-4.66-2.04-6.52-.69-.99-1.53-1.86-2.48-2.6,1-2.45,3.41-4.19,6.23-4.19h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkgreen01);
export default __webpack_public_path__ + "static/media/darkgreen01.601d59e3defac9fc7244347b5ecedd8f.svg";
export { ForwardRef as ReactComponent };